import React from 'react';
import ESIInclude from '../../esi';
import { HeaderWrapper as PremiumHeaderWrapper } from '../premium-components/header-wrapper/HeaderWrapper';
import { HeaderWrapper } from '../components/header-wrapper/HeaderWrapper';
import { EnvVarsFeaturesContext } from './EnvVarsFeaturesContext';
import { UserContextProvider } from './UserContext';

export const HeaderApp = ({ initialState = {} }) => {
  const {
    envVars = {},
    features = {},
    categories = {},
    headerClientConfigQueryParameters = {},
    query = {},
    notificationBannerFolder = '',
    stickySearchHeader = '',
    isNavExperimentActive = '',
    premiumHeaderIsActive = false,
    convoSearchIsActive = false,
    stayUpdatedIsActive = false,
  } = initialState;

  return (
    <div>
      <ESIInclude
        id="experimentation-esi"
        src="/esi/experimentation/page-load-experiments?includeMonetateExperiences=true"
        data-testid="experimentation-esi"
      />
      <UserContextProvider>
        <EnvVarsFeaturesContext.Provider
          value={{
            envVars,
            features,
            categories,
            headerClientConfigQueryParameters,
            query,
            stickySearchHeader,
            isNavExperimentActive,
            premiumHeaderIsActive,
            convoSearchIsActive,
            stayUpdatedIsActive,
          }}
        >
          {premiumHeaderIsActive ? (
            <PremiumHeaderWrapper features={features} />
          ) : (
            <HeaderWrapper features={features} />
          )}
          {convoSearchIsActive && (
            <div
              style={{
                position: 'absolute',
                top: 3,
                left: 3,
                zIndex: 9999,
              }}
            >
              <ESIInclude
                id="header-conversational-search"
                src={`${envVars.convoSearchPath}`}
              />
            </div>
          )}
          {notificationBannerFolder && (
            <ESIInclude
              id="header-notification-banner"
              src={`/${envVars.bannerPath}/${notificationBannerFolder}/index.html`}
              data-testid="header-notification-banner"
            />
          )}
        </EnvVarsFeaturesContext.Provider>
      </UserContextProvider>
    </div>
  );
};

HeaderApp.displayName = 'HeaderApp';
